const BLOCKPOT_TESTNET_ADDRESSES: { [key: string]: `0x${string}` } = {
    'aggregatorV3': '0x0153A3A95c5dF3914319086D7E9D92D96B5118c9',
    'blockPotToken': '0x3c618cb06271c4b9a08424d4c33449529D16f137',
    'configManager': '0xa691ac9fb5556ed4FA973dBBfB6F5CD3f18E0D51',
    'contributorsRewardTracker': '0x802894e89DAfca5055C567F66fe7acDd47cc697B',
    'fundsManager': '0x750Bf4071A87a2431d8b678e07853d40494E4aEe',
    'lottery': '0xBF0c13Dc169fFfED4CBb74224CB655bc608FbD24',
    'quickGame': '0xc2597F496b5f3D0661885b0cB36809f3305cF22C',
    'quickGameFundsManager': '0xd6F401E8F5466e8f1d8BeDd1D240086179920441',
    'lotteryRandomNumberProvider': '0xdf77297F4334B2D146A34cfC5A5A791a4d8897E1',
    'numberGenerator': '0xa04C5c3c6849A87384835AFe35e23366b94fE1E6',
    'referralManager': '0x4d954ebB1AEb4F4310C76FcF2881405856E0Abaf',
    'rewardLostAndFound': '0xBf327B8fc6953650Cd324182FaA381A8636B4Ff9',
    'rewardTracker': '0x7123A6d50c543aC145F25d87765147f0E86952fC',
    'weth': '0x90fF98975aE9cFB6cCe2eF179e41C87913820E6b',
    'wrapper': '0x52CE67d6180fd888cCd01f881F57615eb74913C0'
}

export default BLOCKPOT_TESTNET_ADDRESSES